//import {createRouter, createWebHashHistory} from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'; 
//该模式配合nginx
/*location / {  
  try_files $uri $uri/ /index.html;  
}  */
import Home from "./views/HomePage.vue";
import NewsList from "./views/NewsList.vue";
import SearchList from "./views/SearchList.vue";
import NewsView from "./views/NewsView.vue";
import VideoView from "./views/VideoView.vue";
import AlbumView from "./views/AlbumView.vue";
import SpecialAll from "./views/SpecialAll.vue";
import SpecialList from "./views/SpecialList.vue";
import ZhengWu from "./views/ZhengWu.vue";


const routes = [
    { path:"/", redirect:{name:"home"}},    
    { path: '/', name:"home", component: Home },
    { path: '/list_:id', name:"list", component: NewsList, props: true},
    { path: '/search', name:"search", component: SearchList, props: true},
    { path: '/article/show-:id', name:"article", component: NewsView, props: true},
    { path: '/video/show-:id', name:"video", component: VideoView, props: true},
    { path: '/album/show-:id', name:"album", component: AlbumView, props: true},
    { path: '/zhuanti/node_:id', name:"special", component: SpecialList, props: true},
    { path: '/zhuanti/index:id', name:"zhuanti", component: SpecialAll, props: true},
    { path: '/zhengwu:id', name:"zhengwu", component: ZhengWu, props: true},
    // 添加一个捕获所有未找到路由的页面  
    { path: '/:catchAll(.*)', component: Home }, // 可以选择性地添加一个通配符路由来处理未知路由  
]

const router = createRouter({
    history: createWebHistory(), // 使用 createWebHistory 来启用 history 模式 
    //history: createWebHashHistory(),
    // 指定hash属性与组件的对应关系
    routes
  })
  

export default router
